import { API_VERSION } from '@/apis/constants';
import { ApiService } from '@/utils/api';

export const BE_INGRESS_URL = process.env.NEXT_PUBLIC_BE_INGRESS_BASE_URL as string;

export const BE_USER_SERVICE_URL = `${BE_INGRESS_URL}/${ApiService.USER}/${API_VERSION[ApiService.USER]}`;

export const BE_REPORT_SERVICE_URL = `${BE_INGRESS_URL}/${ApiService.REPORT}/${API_VERSION[ApiService.REPORT]}`;
export const BE_MAKGEOLLI_SERVICE_URL = `${BE_INGRESS_URL}/${ApiService.MAKGEOLLI}/${
  API_VERSION[ApiService.MAKGEOLLI]
}`;
export const BE_GIN_SERVICE_URL = `${BE_INGRESS_URL}/${ApiService.GIN}/${API_VERSION[ApiService.GIN]}`;
